import { Button } from '@/components/ui/button';
import PaddockAvatar from '@/components/ui/paddock-avatar/paddock-avatar';
import { PDKNoUserIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils.ts';
import type { FinanceManager } from '@/models/types';
import type { RefObject } from 'react';

const FinanceManagerBadge = ({
  financeManager,
  hideNameAndCopy,
  useAbbreviations,
  financeManagerRef,
  className,
}: {
  financeManager: FinanceManager | null | undefined;
  hideNameAndCopy?: boolean;
  useAbbreviations?: boolean;
  financeManagerRef?: RefObject<HTMLButtonElement | null> | undefined;
  className?: string;
}) => {
  return (
    <Button
      variant="ghost"
      className={cn('p-1 h-fit', className)}
      ref={financeManagerRef}
    >
      {financeManager && (
        <div className="flex flex-row gap-2 items-center">
          <PaddockAvatar
            src={financeManager.avatar}
            alt={`${financeManager.first_name} ${financeManager.last_name}`}
            fallback={`${financeManager.first_name.charAt(0)} ${financeManager.last_name.charAt(0)}`}
            className="w-5 h-5 rounded-full"
          />
          {!hideNameAndCopy && (
            <p className="rounded text-xs  text-gray-600 text-center">
              {useAbbreviations
                ? `${financeManager.first_name.charAt(0)}${financeManager.last_name.charAt(0)}`
                : `${financeManager.first_name} ${financeManager.last_name}`}
            </p>
          )}
        </div>
      )}
      {!financeManager && (
        <div className="flex flex-row gap-2">
          <PDKNoUserIcon className="h-3.5 w-3.5" />
          {!hideNameAndCopy && (
            <p className="rounded text-xs  text-gray-600">
              {useAbbreviations ? 'Add FM' : 'Add finance manager'}
            </p>
          )}
        </div>
      )}
    </Button>
  );
};

export default FinanceManagerBadge;
